import { render, staticRenderFns } from "./PartnerProductCard.vue?vue&type=template&id=2c994862&scoped=true&"
import script from "./PartnerProductCard.vue?vue&type=script&lang=js&"
export * from "./PartnerProductCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerProductCard.vue?vue&type=style&index=0&id=2c994862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c994862",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
